"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Utility to split props based on an array of keys
 */

function splitProps(props, keys) {
  var matchedProps = {};
  var remainingProps = {};
  var propKeys = Object.keys(props);

  for (var i = 0; i < propKeys.length; i++) {
    var propKey = propKeys[i];
    var propValue = props[propKey];

    if (keys.includes(propKey)) {
      matchedProps[propKey] = propValue;
    } else {
      remainingProps[propKey] = propValue;
    }
  }

  return {
    matchedProps: matchedProps,
    remainingProps: remainingProps
  };
}

exports.default = splitProps;